<div class="content-card">
  <mat-tab-group (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
    <mat-tab
      [visibleWithPermissions]="['ShowAllLegalizations', 'ShowEmployerObjectLegalizations']"
      [label]="'Legalization.Register.LegalizationsProcesses' | translate"
      >
    </mat-tab>
    <mat-tab
      [visibleWithPermissions]="['GetAllLegalizationDocuments', 'GetEmployerObjectLegalizationDocuments']"
      [label]="'Legalization.Register.Documents' | translate"
      >
    </mat-tab>
  </mat-tab-group>
</div>

@switch (listType) {
  @case (LegalizationListType.Legalizations) {
    <app-legalization-list ></app-legalization-list>
  }
  @case (LegalizationListType.Documents) {
    <app-legalization-all-documents-list ></app-legalization-all-documents-list>
  }
}
